import React from 'react';
import { STATIC_UPPSALA_SVG_URL } from '../../lib/constants';
const Dropdown = (props) => {
    return (React.createElement("div", { className: `${props.className ?? ''}`, style: {
            marginBottom: '15px',
            ...props.style,
        } },
        React.createElement("label", { htmlFor: props.id, className: "form-label" }, props.labelName),
        React.createElement("div", { className: "flex flex-row" },
            React.createElement("select", { id: props.id, name: props.name, value: props.selected, onChange: (e) => props.onChange(e.target.value), className: `form-control ${renderValidationClassName()}`, style: {
                    width: '250px',
                    height: '40px',
                    borderRadius: '0px',
                    WebkitAppearance: 'menulist',
                    appearance: 'menulist',
                } },
                props.unselectedOption && React.createElement("option", { key: 0 }, props.unselectedOption),
                props.options.map((option) => (React.createElement("option", { key: option, value: option }, option)))),
            React.createElement("div", { style: { width: '25px', marginLeft: '10px', display: 'flex', justifyContent: 'center' } }, renderIcon()))));
    function renderValidationClassName() {
        if (props.valid === true)
            return 'validation-successful';
        if (props.valid === false)
            return 'validation-error';
        return '';
    }
    function renderIcon() {
        if (props.valid === true)
            return React.createElement("img", { src: STATIC_UPPSALA_SVG_URL + 'check-mark.svg', alt: "check-mark" });
        if (props.valid === false)
            return React.createElement("img", { src: STATIC_UPPSALA_SVG_URL + 'x-mark.svg', alt: "x-mark" });
        return null;
    }
};
export default Dropdown;
